import { Component, Input } from '@angular/core';

@Component({
  selector: 'dashboard-plants-production',
  templateUrl: './plants-production.component.html',
  styleUrls: ['./plants-production.component.scss']
})
export class DashboardPlantsProductionComponent {
  @Input() plants: any[] = [];
}
